<div class="not-found-container">
    <div class="flex justify-between mb-10">
      <div
        class="logo-icon"
        style="background-image: url('assets/img/logo_unchk.png')"
      ></div>
      <div
        class="logo-icon"
        style="
          background-image: url('assets/img/logo_master_card.png');"
      ></div>
    </div>
  
    <div class="not-found-container2">
      <h2 class="not-found-text2">
        Un email de réinitilisation de mot de passe vous a été envoyer à l'adresse <strong>{{email}}</strong> .
        Merci de cliquer sur le lien pour changer votre mot de passe. vous allez être redirigé automatiquement vers la page de connexion 
      </h2>
    </div>
  </div>
  
  